import { render, staticRenderFns } from "./synthesisDetail.vue?vue&type=template&id=2a6f8060&scoped=true&"
import script from "./synthesisDetail.vue?vue&type=script&lang=js&"
export * from "./synthesisDetail.vue?vue&type=script&lang=js&"
import style0 from "./synthesisDetail.vue?vue&type=style&index=0&id=2a6f8060&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f8060",
  null
  
)

export default component.exports